import clsx from "clsx"
import { FC, PropsWithChildren } from "react"
import { useLocation } from "react-router-dom"
import { PORTAL_CONTAINER_ID } from "utils/getPortalContainer"
import { loaderLogo } from "assets/icons"
import { useWebAppViewport } from "@/providers/WebAppViewport"
import styles from "./index.module.scss"

const isProd = ["staging", "production"].includes(import.meta.env.VITE_NODE_ENV)

const FULLSCREEN_ROUTES = ["/login"]

export const AppShell: FC<PropsWithChildren> = ({ children }) => {
  const { isTelegramEnv } = useWebAppViewport()
  const { pathname } = useLocation()

  const isFullscreen =
    isTelegramEnv || FULLSCREEN_ROUTES.some((r) => pathname.startsWith(r))

  if (isFullscreen) {
    return (
      <div id={PORTAL_CONTAINER_ID} className={styles.containerTelegram}>
        {children}
      </div>
    )
  }

  return (
    <>
      <div className={styles.background} />
      <div className={styles.wrapper}>
        <div className={styles.logo}>
          <img src={loaderLogo} alt="Labrador logo" />
        </div>
        <div
          id={PORTAL_CONTAINER_ID}
          className={clsx(styles.container, isProd && styles.containerProd)}
        >
          {children}
        </div>
      </div>
    </>
  )
}
